import { __awaiter } from "tslib";
import Action from "../Action";
import text from "../../../store/text";
import { STEP_TEXT_IS_SHOWING } from "../Conditions";
export default class StepText extends Action {
    constructor(step) {
        super();
        this._name = "StepText";
        this.step = step;
        this.condition(STEP_TEXT_IS_SHOWING);
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            ctx.stepTextComponent.setText(text.get().steps[this.step].text);
        });
    }
    toString() {
        return `${super.toString()}, step: ${this.step}`;
    }
}
